const getters = {
  language: state => state.language
}

export default getters
